import { CustomMenuItemProps, useGridMenuItem } from '@mint-lib/ag-grid/react';
import type { FC, SVGProps } from 'react';

import {
  itemVariants,
  Label,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import type { ApprovalTableItemData } from '../../../types/approversTable.js';

export type ApprovalContextMenuItemParams = {
  IconComponent: FC<SVGProps<SVGSVGElement>>;
  color?: 'primary' | 'error';
  a11yLabel: string;
};

type Props = Omit<
  CustomMenuItemProps<ApprovalTableItemData>,
  'menuItemParams'
> & {
  menuItemParams: ApprovalContextMenuItemParams;
};

const MenuItem: FC<Props> = ({
  name,
  disabled,
  cssClasses,
  menuItemParams: { IconComponent, color = 'primary', a11yLabel },
}) => {
  useGridMenuItem({
    configureDefaults: () => true,
  });

  return (
    <button
      type="button"
      role="menuitem"
      data-dd-action-name={a11yLabel}
      className={cn(
        itemVariants({ popoverItem: 'default' }),
        'align-center flex! w-[146px] gap-2',
        cssClasses,
      )}
      disabled={disabled}
    >
      <IconComponent
        className={cn(typographyVariants({ color }), 'h-4 w-4 fill-current')}
      />
      <Label
        className="flex-1 shrink-0 grow cursor-[inherit]"
        variant="bodyShort01"
        color={color}
      >
        {name}
      </Label>
    </button>
  );
};

export default MenuItem;
